import { render, staticRenderFns } from "./CameraButton.vue?vue&type=template&id=2dd7234a&lang=pug&"
import script from "./CameraButton.vue?vue&type=script&lang=ts&"
export * from "./CameraButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports